import { render, staticRenderFns } from "./pageName.vue?vue&type=template&id=aa1ee19c&scoped=true"
import script from "./pageName.vue?vue&type=script&lang=js"
export * from "./pageName.vue?vue&type=script&lang=js"
import style0 from "./pageName.vue?vue&type=style&index=0&id=aa1ee19c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa1ee19c",
  null
  
)

export default component.exports